/**
 * @fileoverview Pure validation and error-mapping helpers for Change Password.
 * @module pages/changePassword/changePasswordValidation
 */
import {
  MAX_PASSWORD_LENGTH,
  MIN_PASSWORD_LENGTH,
  REQUIRED_PASSWORD_RULE_MATCHES,
} from "./changePasswordConstants.js";

/**
 * @param {string} password
 * @returns {boolean}
 */
export const isPasswordValid = (password) => {
  if (
    password.length < MIN_PASSWORD_LENGTH ||
    password.length > MAX_PASSWORD_LENGTH
  ) {
    return false;
  }
  const regex = [/\d/, /[A-Z]/];
  let matches = 0;
  for (let r = 0; r < regex.length; r++) {
    if ((password.match(regex[r]) || []).length > 0) {
      matches++;
    }
  }
  return matches === REQUIRED_PASSWORD_RULE_MATCHES;
};

/**
 * Maps API/Cognito errors from password confirmation to UI error state.
 * @param {{ message?: string }} error
 * @returns {{ message: string, errorType: "password" | "confirmationCode" }}
 */
export const mapConfirmPasswordError = (error) => {
  let message = "";
  let errorType = "password";

  if (error.message === "UserNotFoundException") {
    message = "NO_ACCOUNT_ASSOCIATED_WITH_EMAIL";
  } else if (error.message === "LimitExceededException") {
    message = "ATTEMPTS_LIMIT_EXCEEDED";
  } else if (error.message === "ExpiredCodeException") {
    message = "VERIFICATION_CODE_EXPIRED";
    errorType = "confirmationCode";
  } else if (error.message === "InvalidPasswordException") {
    message = "PASSWORD_DOES_NOT_MEET_REQUIREMENTS";
  } else if (error.message === "CodeMismatchException") {
    message = "INVALID_VERIFICATION_CODE";
    errorType = "confirmationCode";
  } else {
    message = "ERROR_CHANGING_PASSWORD";
  }

  return { message, errorType };
};
